import Game from "./Game";

console.log("loading Main.ts");


let game = new Game();
game.start();
